// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Y8Dn","ranges":"BmiRanges_ranges__2ZQze"};